import { Icon } from '@buggy/shared'
import { Tooltip } from 'antd'
import React, { FunctionComponent } from 'react'
import styled, { css, SimpleInterpolation, useTheme } from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'

interface SponsoredTagProps {
  iconOnly?: boolean
}

const SponsoredTag: FunctionComponent<SponsoredTagProps> = ({ iconOnly }) => {
  const { formatMessage } = useIntl()
  const theme = useTheme()

  return (
    <Box $iconOnly={iconOnly}>
      <Tooltip
        placement='bottom'
        title={
          iconOnly
            ? formatMessage({ id: 'kol:content_advertorial' })
            : undefined
        }
      >
        <Icon
          color={theme.colors.base.grey.grey9}
          fontSize={iconOnly ? 14 : 13}
          name='payment-outlined'
        />
      </Tooltip>
      {!iconOnly && (
        <Text>{formatMessage({ id: 'kol:content_advertorial' })}</Text>
      )}
    </Box>
  )
}

const Box = styled.div<{ $iconOnly: SponsoredTagProps['iconOnly'] }>`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  gap: 2px;
  border-radius: 3px 0;
  background: ${({ theme }): string => theme.colors.gray10};

  ${({ $iconOnly }): SimpleInterpolation =>
    $iconOnly
      ? css`
          padding: 5px 8px;
        `
      : css`
          padding: 2px 8px;
        `}
`

const Text = styled.div`
  color: ${({ theme }): string => theme.colors.white};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export default SponsoredTag
